import { render, staticRenderFns } from "./liveList.vue?vue&type=template&id=01a6957e&scoped=true"
import script from "./liveList.vue?vue&type=script&lang=js"
export * from "./liveList.vue?vue&type=script&lang=js"
import style0 from "./liveList.vue?vue&type=style&index=0&id=01a6957e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a6957e",
  null
  
)

export default component.exports